'use strict'

const rawRequired = Symbol('@fastify/swagger.rawRequired')

module.exports = {
  rawRequired
}
